import React, { Children, cloneElement, Component } from 'react';
import classNames from 'classnames';
import warning from '../_util/warning';
import RcDropdown from '../rc-components/dropdown';
import ConfigContext from '../config-provider/ConfigContext';
export default class Dropdown extends Component {
    constructor() {
        super(...arguments);
        this.renderOverlay = () => {
            const { overlay } = this.props;
            const overlayElements = typeof overlay === 'function' ? overlay() : overlay;
            if (overlayElements) {
                const overlayElement = Children.only(overlayElements);
                const overlayProps = overlayElement.props;
                warning(!overlayProps.mode || overlayProps.mode === 'vertical', `mode="${overlayProps.mode}" is not supported for Dropdown's Menu.`);
                // menu cannot be selectable in dropdown defaultly
                const { selectable = false, focusable = true } = overlayProps;
                return typeof overlayElement.type === 'string' ? overlayElement : cloneElement(overlayElement, {
                    mode: 'vertical',
                    selectable,
                    focusable,
                });
            }
        };
    }
    static get contextType() {
        return ConfigContext;
    }
    getTransitionName() {
        const { placement = '', transitionName } = this.props;
        if (transitionName !== undefined) {
            return transitionName;
        }
        if (placement.indexOf('top') >= 0) {
            return 'slide-down';
        }
        return 'slide-up';
    }
    render() {
        const { children, prefixCls: customizePrefixCls, trigger, disabled, } = this.props;
        const { getPrefixCls } = this.context;
        const prefixCls = getPrefixCls('dropdown', customizePrefixCls);
        const child = Children.only(children);
        const dropdownTrigger = cloneElement(child, {
            className: classNames(child.props.className, `${prefixCls}-trigger`),
            disabled,
        });
        const triggerActions = disabled ? [] : trigger;
        let alignPoint;
        if (triggerActions && triggerActions.indexOf('contextMenu') !== -1) {
            alignPoint = true;
        }
        return (React.createElement(RcDropdown, Object.assign({ alignPoint: alignPoint }, this.props, { prefixCls: prefixCls, transitionName: this.getTransitionName(), trigger: triggerActions, overlay: this.renderOverlay }), dropdownTrigger));
    }
}
Dropdown.displayName = 'Dropdown';
Dropdown.defaultProps = {
    mouseEnterDelay: 0.15,
    mouseLeaveDelay: 0.1,
    placement: 'bottomLeft',
};
